// extracted by mini-css-extract-plugin
export default {"selectorWrapper":"userTypesSelector_selectorWrapper__XxUX+","selectedGroup":"userTypesSelector_selectedGroup__x6sCC","groupItem":"userTypesSelector_groupItem__9T7N9"};